import React from 'react';
import './pages.css';
import PhotosMainLoop from '../components/photosMainLoop';

function PhotosMain({ handleLogout }) {

    return (
        <>
            <section className="mainSection">
                <nav className="hero">
                    <h1 className="sr-only">Photography Main Page</h1>
                    <button onClick={handleLogout}>Log Out</button>
                </nav>

                <main>

                    <PhotosMainLoop />

                </main>

            </section>
        </>
    );
}

export default PhotosMain;